import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const PrevioMitur = () => {
  const {
    validationDocuments: { previous_mitur }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3} rowGap={1}>
      <Grid item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_previous_mitur}
          label="Previo MITUR"
          maxSize={3}
          minSize={0}
          disabled={previous_mitur?.disabled}
          typeKey={CValidationDocumentKeys.PreviousMitur}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_file_previous_mitur}
          label="Fecha de emisión"
          disabled={previous_mitur?.disabled}
        />
      </Grid>
    </Grid>
  );
};

export default PrevioMitur;
